import { Board } from "../Model/Board";
import { Cell } from "../Model/Cell";
export class BoardsFactory {
    constructor(eventsChannelsFactory) {
        this.eventsChannelsFactory = eventsChannelsFactory;
    }
    createBoard(id, gameId, playerId, cells) {
        return new Board(this.eventsChannelsFactory, id, gameId, playerId, cells);
    }
    createBoardFromDto(dto) {
        return this.createBoard(dto.id, dto.gameId, dto.playerId, dto.cells.map((cell) => cell ? new Cell(cell.number, cell.checked) : null));
    }
}
